interface HazardEvent {
  title: string;
}
export const hazardEvent: HazardEvent[] = [
  {
    title: "PROBABILITY",
  },
  {
    title: "HUMAN IMPACT",
  },
  {
    title: "PROPERTY IMPACT",
  },
  {
    title: "BUSINESS IMPACT",
  },
  {
    title: "PREPAREDNESS",
  },
  {
    title: "INTERNAL RESPONSE",
  },
  {
    title: "EXTERNAL RESPONSE",
  },
  {
    title: "RISK",
  },
];
